import { GetAdminIdeaResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches one idea's admin detail (GET /v1/admin/ideas/:id). Disabled until the id
 * is a valid positive number. Gated server-side by AdminGuard; a missing id returns
 * 404.
 */
export const useAdminIdea = (id: number) => {
	return useQuery<GetAdminIdeaResponse>({
		queryKey: queryKeys.adminIdea(id),
		queryFn: async () => {
			const response = await api.get<GetAdminIdeaResponse>(`/admin/ideas/${id}`)
			return response.data
		},
		enabled: Number.isFinite(id) && id > 0,
	})
}
